<div class="subheader">
  <ng-container i18n>Overview</ng-container>
</div>

<ng-container *ngIf="hostel">
  <!-- Ensure this div has the #description reference -->
  <div #description class="text light description" [ngClass]="{'truncate-lines': !showFullDescription}">
    {{getHostelDescription()}}
  </div>
  <!-- The view more/less button -->
  <div *ngIf="isLongDescription" class="view-more" (click)="toggleDescription()">
    {{ showFullDescription ? 'View Less' : 'View More' }}
    <svg-icon [src]="showFullDescription ? '/assets/icons/arrow_up.svg' : '/assets/icons/arrow_down_ios.svg'" svgClass="icon"></svg-icon>
  </div>
</ng-container>


<ng-container *ngIf="!hostel">
  <div class="text light description skeleton description" style="margin-bottom: 1.5rem;"></div>
</ng-container>

<!-- <div class="cards">
  <div class="card green">
    <div class="card_header">
      {{hostel?.overallRating | number: '1.0-2'}}
    </div>
    <div class="card_content">
      <div class="card_subheader">
        Awesome!
      </div>
      <div class="card_text truncate-2-lines">
        {{hostel?.totalReviews ?? 0}}&nbsp;reviews
      </div>
    </div>
  </div> -->
  <!-- <div class="card">
    <div class="card_header">
      <div class="icon">
        <svg-icon style="height: 40px" [svgStyle]="{'width.px': 25, 'height.px': 40}" src="/assets/icons/user_2.svg"></svg-icon>
      </div>
    </div>
    <div class="card_content">
      <div class="card_subheader">
        13 other travelers
      </div>
      <div class="card_text truncate-2-lines">
        Will be staying at this hostel between the selected dates
      </div>
    </div>
  </div> -->
  <!-- <div class="card pointer" (click)="cardClick();">
    <div class="card_header">
      <div class="icon">
        <svg-icon style="height: 40px" [svgStyle]="{'width.px': 25}" src="/assets/icons/thumb_2.svg"></svg-icon>
      </div>
    </div>
    <div class="card_content">
      <div class="card_subheader">
        Recommend this hostel
      </div>
      <div class="card_text truncate-2-lines">
        Recommend this hostel to another traveler to earn 4% of their booking
      </div>
    </div>
  </div>
  <div class="card pointer" (click)="cardClick();">
    <div class="card_header">
      <div class="icon">
        <svg-icon style="height: 40px" [svgStyle]="{'width.px': 25, 'height.px': 40}" src="/assets/icons/map.svg"></svg-icon>
      </div>
    </div>
    <div class="card_content">
      <div class="card_subheader">
        Add to map
      </div>
      <div class="card_text truncate-2-lines">
        Add this hostel to a map so you can share your journey with other travelers
      </div>
    </div>
  </div> -->
<!-- </div> -->
